
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authors/[id]",
      function () {
        return require("private-next-pages/authors/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authors/[id]"])
      });
    }
  